module.exports = __webpack_public_path__ + "img/DM-Healthcare-Pvt-Ltd.7a847be8.jpg";